<template>
  <div>
    <van-popup
      v-model="show"
      position="bottom"
      round
      :style="{ minHeight: '32%', paddingTop: '0.6rem' }"
      @closed="closed"
    >
      <div class="pay-panel">
        <div class="topTitle">
          <div class="seizeseat"></div>
          <div class="centertitle">支付方式明细</div>
          <div class="close-icon" @click="closed">
            <van-icon size="1.1rem" name="cross" color="#999" />
          </div>
        </div>

        <div v-if="!payList || !payList.length" class="empty-block">
          <van-icon name="balance-o" size="1.6rem" color="#d8d8d8" />
          <div class="empty-text">暂无支付记录</div>
        </div>

        <div v-else class="pay-list">
          <div
            v-for="(item, index) in payList"
            :key="index"
            class="payitem"
          >
            <div class="lifeText">
              <div class="pay-name">{{ item.showName }}</div>
            </div>
            <div
              class="rightText"
              :class="{
                'amount-negative': isNegative(item.showPrice),
                'amount-positive': !isNegative(item.showPrice),
              }"
            >
              {{ formatAmount(item.showPrice) }}
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "",
  props: {

    payList: {
      type: Array,
    },
  },
  data() {
    return {
      show: true,
    };
  },
  components: {},
  methods: {
    closed() {
      this.$emit("closed", false);
    },
    isNegative(value) {
      if (value === null || value === undefined) {
        return false;
      }
      const str = String(value).trim();
      return str.startsWith('-');
    },
    formatAmount(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      const str = String(value).trim();
      // 已经带有 + 或 - 前缀时直接返回
      if (str.startsWith('+') || str.startsWith('-')) {
        return str;
      }
      const num = Number(str);
      if (isNaN(num)) {
        return str;
      }
      return (num >= 0 ? '+' : '-') + Math.abs(num);
    },
  },
  mounted() {
  },
  computed: {},
  watch: {},
};
</script>

<style lang='scss' scoped>
.pay-panel {
  padding: 0 1rem 1rem;
}

.topTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 0;
  margin-bottom: 0.3rem;

  .seizeseat {
    width: 1.2rem;
  }

  .centertitle {
    font-size: 1rem;
    font-weight: 600;
    color: #333;
  }

}

.close-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pay-list {
  background: #f7f8fa;
  border-radius: 0.9rem;
  padding: 0.2rem 0.4rem;
  max-height: 13rem;
  overflow-y: auto;
}

.empty-block {
  padding: 1.4rem 0 1.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .empty-text {
    margin-top: 0.4rem;
    font-size: 0.85rem;
    color: #999;
  }
}

.payitem {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.55rem 0.6rem;
  border-radius: 0.6rem;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.02);
  margin: 0.25rem 0;

  .lifeText {
    flex: 1;
    min-width: 0;
  }

  .rightText {
    min-width: 4.5rem;
    text-align: end;
    font-weight: 600;
    font-size: 0.9rem;
  }
}

.pay-name {
  font-size: 0.9rem;
  color: #333;
  font-weight: 500;
  line-height: 1.4;
  word-break: break-all;
}

.amount-negative {
  color: #ee0a24;
}

.amount-positive {
  color: #07c160;
}
</style>